// extracted by mini-css-extract-plugin
export default {"burgerContainer":"styles_burgerContainer__gZ04Q","burgerButton":"styles_burgerButton__yBwAB","menu":"styles_menu__qqHcW","menuList":"styles_menuList__Ci+E5"};